function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = e(require("dragscroll")) : "function" == typeof define && define.amd ? define(["dragscroll"], e) : t.scrollNav = e();
}(this, function () {
  "use strict";

  var t = {
    moving: !1,
    direction: "none",
    overflow: "none",
    distance: 150,
    position: 0
  },
      e = {
    get: function get(e) {
      return t[e];
    },
    positionIncrease: function positionIncrease(e) {
      var n = t.position + e;
      t = Object.assign(t, {
        position: n
      });
    },
    set: function set(e, n) {
      t = Object.assign(t, function (t, e, n) {
        return e in t ? Object.defineProperty(t, e, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : t[e] = n, t;
      }({}, e, n));
    }
  },
      n = function n(t) {
    var e = Math.floor,
        n = t.getBoundingClientRect(),
        i = e(n.right);
    return {
      left: e(n.left),
      right: i
    };
  },
      i = function i(t) {
    var i = t.container,
        r = t.leftBtn,
        o = t.rightBtn,
        a = t.wrapper,
        s = function (t, e) {
      return function (n) {
        "left" === n ? (t.setAttribute("aria-hidden", !1), e.setAttribute("aria-hidden", !0)) : "right" === n ? (t.setAttribute("aria-hidden", !0), e.setAttribute("aria-hidden", !1)) : "both" === n ? (t.setAttribute("aria-hidden", !1), e.setAttribute("aria-hidden", !1)) : (t.setAttribute("aria-hidden", !0), e.setAttribute("aria-hidden", !0));
      };
    }(r, o);

    return function () {
      var t = function (t, e) {
        var i = n(e),
            r = n(t);
        return i.left > r.left && i.right < r.right ? "both" : r.left < i.left ? "left" : r.right > i.right ? "right" : "none";
      }(i, a);

      e.set("overflow", t), a.setAttribute("data-overflowing", t), s(t);
    };
  };

  return function (t) {
    document.documentElement.classList.remove("no-js"), document.documentElement.classList.add("js");
    var n = "string" == typeof t ? document.getElementById(t) : t;

    if (n) {
      var r = function (t) {
        return {
          container: document.getElementById(t.getAttribute("data-container")),
          leftBtn: document.getElementById(t.getAttribute("data-left-btn")),
          rightBtn: document.getElementById(t.getAttribute("data-right-btn")),
          wrapper: document.getElementById(t.getAttribute("data-wrapper"))
        };
      }(n),
          o = r.container,
          a = r.leftBtn,
          s = r.rightBtn,
          c = r.wrapper,
          u = i(r);

      u(0);

      var d = function (t) {
        return function (n, i) {
          return function (r) {
            r.preventDefault(), e.get("moving") || (n(e), e.set("moving", !0), e.set("direction", i), t());
          };
        };
      }(u);

      a.addEventListener("click", d(function (t, e) {
        return function (n) {
          var i = n.get("overflow");

          if ("left" === i || "both" === i) {
            var r = e.scrollLeft;
            r < 2 * n.get("distance") ? (n.positionIncrease(-r), t.style.transform = "translateX(" + r + "px)") : (n.positionIncrease(-n.get("distance")), t.style.transform = "translateX(" + n.get("distance") + "px)"), t.classList.remove("no-transition");
          }
        };
      }(o, c), "left")), s.addEventListener("click", d(function (t, e) {
        return function (n) {
          var i = n.get("overflow");

          if ("right" === i || "both" === i) {
            var r = t.getBoundingClientRect().right,
                o = e.getBoundingClientRect().right,
                a = Math.floor(r - o);
            a < 2 * n.get("distance") ? (n.positionIncrease(a), t.style.transform = "translateX(-" + a + "px)") : (n.positionIncrease(n.get("distance")), t.style.transform = "translateX(-" + n.get("distance") + "px)"), t.classList.remove("no-transition");
          }
        };
      }(o, c), "right")), function (t, n) {
        t.addEventListener("transitionend", function () {
          t.style.transform = "none", t.classList.add("no-transition"), n.scrollLeft = e.get("position"), e.set("moving", !1);
        }, !1);
      }(o, c), function (t, e) {
        var n = 0,
            i = !1;
        t.addEventListener("scroll", function () {
          n = window.scrollY, i || window.requestAnimationFrame(function () {
            e(n), i = !1;
          }), i = !0;
        });
      }(c, u);
    }
  };
});